// extracted by extract-css-chunks-webpack-plugin
module.exports = {"grid":"_36Uhs","list":"_2xSsl"};